<div class="modal-header">
    <h4 class="modal-title">
        {{ title() | translate }}
        <span class="fw-light mx-1">
            @if (displayLabel) {
                - {{ displayLabel }}
            }
        </span>
    </h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body" [formGroup]="model">
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="titleAE"
                formControlName="titleAE"
                textAlignment="right"
                [required]="true"
                [invalid]="submitted && model.get('titleAE')?.invalid!"
                [label]="'common.form.label.titleAE' | translate"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="titleEN"
                formControlName="titleEN"
                textAlignment="left"
                [required]="true"
                [invalid]="submitted && model.get('titleEN')?.invalid!"
                [label]="'common.form.label.titleEN' | translate"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="dscAE"
                formControlName="dscAE"
                textAlignment="right"
                [isTextArea]="true"
                [invalid]="submitted && model.get('dscAE')?.invalid!"
                [label]="'common.form.label.descriptionAE' | translate"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="dscEN"
                formControlName="dscEN"
                textAlignment="left"
                [isTextArea]="true"
                [invalid]="submitted && model.get('dscEN')?.invalid!"
                [label]="'common.form.label.descriptionEN' | translate"
            />
        </div>
    </div>

    @if (!isUaeAndCountry()) {
        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    controlName="dataSourceAE"
                    formControlName="dataSourceAE"
                    textAlignment="right"
                    [invalid]="submitted && model.get('dataSourceAE')?.invalid!"
                    [label]="'metrics.data_source_ae' | translate"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    controlName="dataSourceEN"
                    formControlName="dataSourceEN"
                    textAlignment="left"
                    [invalid]="submitted && model.get('dataSourceEN')?.invalid!"
                    [label]="'metrics.data_source_en' | translate"
                />
            </div>
        </div>
    }

    <div class="row">
        <div class="col-12">
            <adaa-form-dropdown
                controlName="typeId"
                formControlName="typeId"
                [required]="true"
                [options]="valueTypeOptions()"
                [invalid]="submitted && model.get('typeId')?.invalid!"
                [label]="'attributes.create.data_type' | translate"
                (inputChanges)="typeIdChanged($event)"
            />
        </div>
    </div>

    @if (typeId === CountryValuesTypes.DATE_RANGE_VALUE || typeId === CountryValuesTypes.LIST_PER_DATE) {
        <div class="row">
            <div class="col-12">
                <h6 class="form-label mx-1 mb-0 mt-1">{{ "attributes.create.list_of_values" | translate }}</h6>
            </div>
        </div>
    }
    @for (item of inNumberValues; track item) {
        @if (typeId === CountryValuesTypes.TEXT) {
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input
                        textAlignment="right"
                        [label]="'international_projects.countries.value_ae' | translate"
                        [setDefaultValue]="item.valueTextAE"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueTextAE')"
                    />
                </div>
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input
                        textAlignment="left"
                        [label]="'international_projects.countries.value_en' | translate"
                        [setDefaultValue]="item.valueTextEN"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueTextEN')"
                    />
                </div>
            </div>
        } @else if (typeId === CountryValuesTypes.NUMBER) {
            <div class="row">
                <div class="col-12">
                    <adaa-form-input
                        inputType="number"
                        [label]="'common.tables.value' | translate"
                        [setDefaultValue]="item.valueNumber"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueNumber')"
                    />
                </div>
            </div>
        } @else if (typeId === CountryValuesTypes.DATE) {
            <div class="row">
                <div class="col-12">
                    <adaa-form-input-date
                        [label]="'common.tables.value' | translate"
                        [setDefaultValue]="item.valueDate"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueDate')"
                    />
                </div>
            </div>
        } @else if (typeId === CountryValuesTypes.DATE_RANGE) {
            <div class="row">
                <div class="col-12">
                    <adaa-form-input-date-range
                        [label]="'common.tables.value' | translate"
                        [setDefaultValue]="item.startDate + ' - ' + item.endDate"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'dateRange')"
                    />
                </div>
            </div>
        } @else if (typeId === CountryValuesTypes.DATE_RANGE_VALUE) {
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input-date-range
                        [setDefaultValue]="item.keyStartDate + ' - ' + item.keyEndDate"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'dateRangeKey')"
                    />
                </div>
                <div
                    [class.col-sm-5]="!isViewMode()"
                    [class.col-xs-11]="!isViewMode()"
                    [class.col-sm-6]="isViewMode()"
                    [class.col-xs-12]="isViewMode()"
                >
                    <adaa-form-input
                        inputType="number"
                        [setDefaultValue]="item.valueText"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueText')"
                    />
                </div>
                @if (!isViewMode() && inNumberValues.length > 1) {
                    <div class="col-sm-1 col-xs-1 d-flex justify-content-center align-items-center">
                        <button type="button" class="btn btn-danger border border-1 text-white" (click)="removeItem(item)">
                            <i class="fa fa-trash-alt"></i>
                        </button>
                    </div>
                }
            </div>
        } @else if (typeId === CountryValuesTypes.LIST_PER_DATE) {
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input-date
                        [setDefaultValue]="item.keyDate"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'keyDate')"
                    />
                </div>
                <div
                    [class.col-sm-5]="!isViewMode()"
                    [class.col-xs-11]="!isViewMode()"
                    [class.col-sm-6]="isViewMode()"
                    [class.col-xs-12]="isViewMode()"
                >
                    <adaa-form-input
                        inputType="number"
                        [setDefaultValue]="item.valueText"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueText')"
                    />
                </div>
                @if (!isViewMode() && inNumberValues.length > 1) {
                    <div class="col-sm-1 col-xs-1 d-flex justify-content-center align-items-center">
                        <button type="button" class="btn btn-danger border border-1 text-white" (click)="removeItem(item)">
                            <i class="fa fa-trash-alt"></i>
                        </button>
                    </div>
                }
            </div>
        } @else if (typeId === CountryValuesTypes.KEY_VALUE) {
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input
                        textAlignment="right"
                        [label]="'international_projects.countries.key_ae' | translate"
                        [setDefaultValue]="item.keyTextAE"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'keyTextAE')"
                    />
                </div>
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input
                        textAlignment="left"
                        [label]="'international_projects.countries.key_en' | translate"
                        [setDefaultValue]="item.keyTextEN"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'keyTextEN')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input
                        textAlignment="right"
                        [label]="'international_projects.countries.value_ae' | translate"
                        [setDefaultValue]="item.valueTextAE"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueTextAE')"
                    />
                </div>
                <div class="col-sm-6 col-xs-12">
                    <adaa-form-input
                        textAlignment="left"
                        [label]="'international_projects.countries.value_en' | translate"
                        [setDefaultValue]="item.valueTextEN"
                        [isDisabled]="isViewMode()"
                        (inputChanges)="inNumberValueChanged(item, $event, 'valueTextEN')"
                    />
                </div>
            </div>
        }
    }
    @if ((typeId === CountryValuesTypes.LIST_PER_DATE || typeId === CountryValuesTypes.DATE_RANGE_VALUE) && !isViewMode()) {
        <div class="row">
            <div class="col-12 p-2 my-2 d-flex justify-content-center align-items-center">
                <button type="button" class="btn btn-primary" (click)="addItem()">{{ "attributes.add_new_lov" | translate }}</button>
            </div>
        </div>
    }

    <div class="row">
        <div class="col-12">
            <adaa-form-input-file
                label="international_projects.countries.logo"
                [onDeleteRemoveFile]="false"
                [isDisabled]="isViewMode()"
                [allowedFileSize]="100024"
                [allowedFiles]="allowedFiles"
                [file]="getImage"
                (inputChanges)="onFilechange($event)"
            />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    @if (!isViewMode()) {
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    }
</div>
